import { useState } from 'react';

import useMentionMedia from '@/hooks/swr/useMentionMedia';
// Hooks
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import PropTypes from 'prop-types';

import { POST, STORY } from '@/lib/posts/postTypes';
// Lib
import { INSTAGRAM } from '@/lib/socialProfile';

// Components
import Modal from '@/components/base/Modal';
import MediaViewerNavigation from '@/components/composite/MediaViewer/MediaViewerNavigation';
import MentionMediaViewerContent from '@/components/pages/listening/widget/MentionMediaViewerContent';

const ModalContent = ({ mediaId, mediaType = POST, mediaRequestParams = {} }) => {
    const { activeSocialProfile } = useActiveSocialProfile();
    const [currentMediaId, setCurrentMediaId] = useState(mediaId);

    const {
        media,
        comments,
        captionReply,
        commentsIsLoadMore,
        loadMoreComments,
        previousMedia,
        nextMedia,
        isLoading,
        isLoadingMore,
        addReply,
        mutateMediaComments
    } = useMentionMedia(activeSocialProfile?.id, currentMediaId, mediaRequestParams);

    return (
        <Modal.Body className="w-full">
            <MediaViewerNavigation
                post={previousMedia}
                postType={mediaType}
                isLoading={isLoading}
                socialNetworkType={activeSocialProfile?.social_network_type ?? INSTAGRAM}
                navAction={() => {
                    if (!isLoading && previousMedia) {
                        setCurrentMediaId(previousMedia?.id);
                    }
                }}
                className="btn-mv-nav-prev"
                navClick={() => {
                    if (!isLoading && previousMedia) {
                        setCurrentMediaId(previousMedia?.id);
                    }
                }}
            />
            <MentionMediaViewerContent
                mediaId={mediaId}
                post={media}
                postType={mediaType}
                socialNetworkType={activeSocialProfile?.social_network_type ?? INSTAGRAM}
                socialNetworkId={activeSocialProfile?.id}
                isLoading={isLoading}
                comments={comments}
                mutateMediaComments={mutateMediaComments}
                addReply={addReply}
                commentsLoading={isLoadingMore}
                commentsIsLoadMore={commentsIsLoadMore}
                loadMoreComments={loadMoreComments}
                captionReply={captionReply}
            />
            <MediaViewerNavigation
                post={nextMedia}
                postType={mediaType}
                isLoading={isLoading}
                socialNetworkType={activeSocialProfile?.social_network_type ?? INSTAGRAM}
                navAction={() => {
                    if (!isLoading && nextMedia) {
                        setCurrentMediaId(nextMedia?.id);
                    }
                }}
                isNext={true}
                className="btn-mv-nav-next"
                navClick={() => {
                    if (!isLoading && nextMedia) {
                        setCurrentMediaId(nextMedia?.id);
                    }
                }}
            />
        </Modal.Body>
    );
};

ModalContent.propTypes = {
    mediaId: PropTypes.string,
    mediaType: PropTypes.oneOf([POST, STORY]),
    mediaRequestParams: PropTypes.object,
    mutateMedias: PropTypes.func
};

const MentionMediaViewerModal = ({
    isOpen,
    toggle,
    mediaId,
    mediaType = POST,
    mediaRequestParams = {},
    mutateMedias
}) => {
    return (
        <Modal size="full" open={isOpen} onDismiss={toggle}>
            <ModalContent
                mediaId={mediaId}
                mediaType={mediaType}
                mediaRequestParams={mediaRequestParams}
                //Pass the mutate function to update the medias cache based on action inside the MediaViewer
                mutateMedias={mutateMedias}
            />
        </Modal>
    );
};

MentionMediaViewerModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    mediaId: PropTypes.string,
    mediaType: PropTypes.oneOf([POST, STORY]),
    mediaRequestParams: PropTypes.object,
    mutateMedias: PropTypes.func
};

export default MentionMediaViewerModal;
